import { render, staticRenderFns } from "./CustomFormRecordAction.vue?vue&type=template&id=2c73bfb1"
import script from "./CustomFormRecordAction.js?vue&type=script&lang=js&external"
export * from "./CustomFormRecordAction.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormRecordAction.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports